// extracted by mini-css-extract-plugin
export default {"container":"style_container__Tbs35","content":"style_content__oIKGD","header":"style_header__PvSSf","description":"style_description__uTUop","CTA":"style_CTA__kG9pq"};